import React from 'react'
import { ZinIcon } from '@tnl/zin-react'
import './InfoList.scss'

export interface InfoListItem {
  icon: string
  label: string
  value: string | number
}

export interface InfoListProps {
  items: InfoListItem[]
  className?: string
}

export const InfoList: React.FC<InfoListProps> = ({ items, className = '' }) => {
  return (
    <ul className={`info-list ${className}`}>
      {items.map((item, index) => (
        <li
          key={`${item.value}-${index}`}
          className="info-list__item">
          {item.icon && (
            <div className="info-list__icon">
              <ZinIcon
                name={item.icon}
                set="fal"
              />
            </div>
          )}
          <div className="info-list__content">
            <div className="info-list__label caption-1">{item.label}</div>
            <div className="info-list__value body-2">{item.value}</div>
          </div>
        </li>
      ))}
    </ul>
  )
}
